import { render, staticRenderFns } from "./runTest.vue?vue&type=template&id=71c8f0b6&scoped=true&"
import script from "./runTest.vue?vue&type=script&lang=js&"
export * from "./runTest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71c8f0b6",
  null
  
)

export default component.exports